const e = {
  name: "Wallet",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,5v30c0,2.8,2.2,5,5,5h33V29h2V19h-2V0H5C2.2,0,0,2.2,0,5z M2,5c0-1.7,1.3-3,3-3h31v2H5v2h31v2H5
			C3.3,8,2,6.7,2,5z M29,29h7v9H5c-1.7,0-3-1.3-3-3V9c0.8,0.6,1.9,1,3,1h31v9h-7c-2.8,0-5,2.2-5,5S26.2,29,29,29z M29,21h9v6h-9
			c-1.7,0-3-1.3-3-3C26,22.3,27.3,21,29,21z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Wallet
};
